import SumPanel from '@/views/finance/components/bill/SumPanel'
import { mapGetters } from 'vuex';
// const isSdLogin = JSON.parse(sessionStorage.getItem('isSdLogin'))


export default{
  components:{
    SumPanel
  },
  computed: {
    ...mapGetters(['platformName'])
  },
  data(){
    return {
      // 全部汇总（完整版）
      sumLabel:{
        totalOilAmount:'加油总金额(元)',
        totalRebateAmount:'让利总金额(元)',
        settlementAmount:'应结算总金额(元)',
        totalSlottingAmount:'通道费总金额(元)',
        amountActivityMerchant:'商家承担直降总金额(元)',
        amountPlatformCouponMerchant:'商家承担平台优惠券总金额(元)',
        merchantCouponAmount:'商家承担商家优惠券总金额',
        merchantVoucher: '商户优惠券售卖金额',
        mctProfitMctAmount: '商家权益卡优惠总金额(元)',
        merchantGrowthPlanAmount: '商家承担增长计划总金额(元)',
        merchantJubaoPlanAmount: '商家承担点金计划总金额(元)',
        merchantCustLockAmount: '商家承担锁客宝总金额（元）',
        merchantMktDiscountAmount: '商家承担营销折扣总金额(元)',
        realSettlementAmount:'实际结算总金额(元)'
      },
      // 团油收单汇总（截流简单版）
      sumLabelSimple: {
        totalOilAmount:'加油总金额(元)',
        totalSlottingAmount:'通道费总金额(元)',
        merchantTotalMarketingAmount: '商家承担营销总金额(元)',
        merchantVoucher: '商户优惠券售卖金额',
        realSettlementAmount:'实际结算总金额(元)'
      },
      // 团油收单汇总（旧版）
      sumLabelOld: {
        totalOilAmount:'加油总金额(元)',
        totalRebateAmount:'让利总金额(元)',
        settlementAmount:'应结算总金额(元)',
        totalSlottingAmount:'通道费总金额(元)',
        amountActivityMerchant:'商家承担直降总金额(元)',
        amountPlatformCouponMerchant:'商家承担平台优惠券总金额(元)',
        merchantCouponAmount:'商家承担商家优惠券总金额',
        merchantVoucher: '商户优惠券售卖金额',
        mctProfitMctAmount:'商家权益卡优惠总金额(元)',
        realSettlementAmount:'实际结算总金额(元)'
      },
      sumInfo:{
        totalOilAmount: '0.00',
        totalRebateAmount: '0.00',
        settlementAmount: '0.00',
        totalSlottingAmount: '0.00',
        amountActivityMerchant: '0.00',
        amountPlatformCouponMerchant: '0.00',
        merchantCouponAmount: '0.00',
        mctProfitMctAmount: '0.00',
        merchantVoucher: '0.00',
        realSettlementAmount: '0.00'
      },
      tipsInfo: {
        totalRebateAmount: '商家基础让利金额',
        settlementAmount: '加油金额（枪价）- 商家让利金额（合同让利）',
        totalSlottingAmount: '订单来源为“团油抖音小程序”的订单或者“商家优惠券来源”为“抖音”的订单，通道费=（应结算金额+商家优惠券售卖金额）*通道费比例；其他类型订单，通道费取固定金额或者用“加油金额或应结算金额*通道费比例”',
        amountActivityMerchant: '商家参与活动承担直降金额',
        merchantCouponAmount: '商家券核销金额',
        merchantTotalMarketingAmount: '为以下8个字段的合计总金额：1、让利总金额(元)：商家基础让利金额； 2、商家承担直降总金额(元) ：商家参与活动承担直降金额；3、商家承担平台优惠券总金额(元)：商家承担平台优惠券总金额；4、商家承担商家优惠券总金额（元）：商家券核销金额；5、商家承担增长计划总金额（元）：商家在增长计划中承担的营销折扣总金额；6、商家承担点金计划总金额（元）：商家在点金计划中承担的营销折扣总金额；7、商家承担锁客宝总金额（元）：商家在锁客宝中承担的营销折扣总金额；8、商家权益卡优惠总金额(元) ：团油特价版业务发放的商户承担的权益卡',
        merchantVoucher: '商家优惠券售卖的成本金额，即用户购买单张优惠券的付款金额',
        mctProfitMctAmount: `特价版业务发放的商户承担的权益卡`,
        merchantGrowthPlanAmount: '商家在增长计划中承担的营销折扣总金额',
        merchantJubaoPlanAmount: '商家点金计划中承担的营销折扣总金额',
        merchantCustLockAmount: '商家在锁客宝中承担的营销折扣总金额',
        merchantMktDiscountAmount: '商家在能链通中承担的营销折扣总金额',
        realSettlementAmount: '加油金额（枪价）-让利总金额-商家承担活动直降金额-商家承担平台优惠券总金额-商家承担商家优惠券总金额+商家优惠券售卖金额-商家权益卡优惠总金额-通道费金额'
      },
      // 团油收单汇总 (完整版)
      sumTuanLabel:{
        totalOilAmount:'加油总金额(元)',
        totalRebateAmount:'让利总金额(元)',
        settlementAmount:'应结算总金额(元)',
        totalSlottingAmount:'通道费总金额(元)',
        amountActivityMerchant:'商家承担直降总金额(元)',
        amountPlatformCouponMerchant:'商家承担平台优惠券总金额(元)',
        merchantCouponAmount:'商家承担商家优惠券总金额',
        merchantVoucher: '商户优惠券售卖金额',
        mctProfitMctAmount: '商家权益卡优惠总金额(元)',
        merchantGrowthPlanAmount: '商家承担增长计划总金额(元)',
        merchantJubaoPlanAmount: '商家承担点金计划总金额(元)',
        merchantCustLockAmount: '商家承担锁客宝总金额（元）',
        merchantMktDiscountAmount: '商家承担营销折扣总金额(元)',
        realSettlementAmount:'实际结算总金额(元)'
      },
      // 团油收单汇总（截流简单版）
      sumTuanLabelSimple: {
        totalOilAmount:'加油总金额(元)',
        totalSlottingAmount:'通道费总金额(元)',
        merchantTotalMarketingAmount: '商家承担营销总金额(元)',
        merchantVoucher: '商户优惠券售卖金额',
        realSettlementAmount:'实际结算总金额(元)'
      },
      // 团油收单汇总（旧版）
      sumTuanLabelOld: {
        totalOilAmount:'加油总金额(元)',
        totalRebateAmount:'让利总金额(元)',
        settlementAmount:'应结算总金额(元)',
        totalSlottingAmount:'通道费总金额(元)',
        amountActivityMerchant:'商家承担直降总金额(元)',
        amountPlatformCouponMerchant:'商家承担平台优惠券总金额(元)',
        merchantCouponAmount:'商家承担商家优惠券总金额',
        merchantVoucher: '商户优惠券售卖金额',
        mctProfitMctAmount: '商家权益卡优惠总金额(元)',
        realSettlementAmount:'实际结算总金额(元)'
      },
      sumTuanInfo:{
        totalOilAmount: '0.00',
        totalRebateAmount: '0.00',
        settlementAmount: '0.00',
        totalSlottingAmount: '0.00',
        amountActivityMerchant: '0.00',
        amountPlatformCouponMerchant: '0.00',
        merchantCouponAmount: '0.00',
        merchantVoucher: '0.00',
        mctProfitMctAmount: '0.00',
        realSettlementAmount: '0.00'
      },
      // pos收单汇总
      sumPosLabel:{
        totalOilAmount:'加油总金额(元)',
        settlementAmount:'应结算总金额(元)',
        totalSlottingAmount:'通道费总金额(元)',
        realSettlementAmount:'实际结算总金额(元)'
      },
      sumFeiTuanLabel: {
        totalBillAmount:'订单总金额(元)',
        totalBillNum:'订单数(笔)',
        totalShouldAmount: '应结算金额(元)',
        totalSettlementAmount:'实际结算金额(元)'
      },
      sumFeiTuanInfo: {
        totalAmount:'订单原价汇总',
        totalNum:'订单的笔数汇总',
        totalShouldAmount: '订单中油站分成金额',
        totalSettlementAmount:'实际结算金额=应结算金额-优惠金额'
      },
      sumPosInfo:{
        totalOilAmount: '0.00',
        settlementAmount: '0.00',
        totalSlottingAmount: '0.00',
        realSettlementAmount: '0.00'
      },
      // 会员卡收单汇总
      sumVipLabel:{
        totalTradeAmount:'订单总金额(元)',
        totalTradeCnt:'订单数(笔)',
        totalSettlementAmount:'应结算金额(元)',
        totalRealSettlementAmount:'实际结算总金额(元)',
        totalServiceFee:'手续费'
      },
      sumVipTipInfo:{
        totalSettlementAmount: '等于订单总金额',
        totalRealSettlementAmount: '扣除优惠的实际参与结算的金额'
      },
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = ''
          }
        },
        // 限制时间选择范围32天
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 31 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  },
  created () {
    this.tipsInfo.mctProfitMctAmount = `${this.platformName}特价版业务发放的商户承担的权益卡`
  }
}
